import React from "react"
import styled from "styled-components"
import { Button as AntdButton } from "antd"
import DrawableCanvas from "./DrawableCanvas"
import { colors, getColor } from "../../../../components/Color"
import { media } from "../../../../components/mediaStyles"

const SignatureLine = styled.div`
  pointer-events: none;
  width: 90%;
  height: 2px;
  margin: 0 5%;
  background: ${getColor("primary", 0.4)};
  position: absolute;
  top: 60%;
  transform: translateY(-50%);
  font-family: Recife Text, serif;
  font-size: 12px;
`

const SignatureWrapper = styled.div`
  position: relative;
`

const Button = styled(AntdButton)`
  font-family: GT America, sans-serif;
  font-weight: 500 !important;
  height: 40px !important;
  background: ${props =>
    props.type === "secondary" ? "white" : colors.teal} !important;
  color: ${props =>
    props.type === "secondary" ? colors.primary : colors.tertiary} !important;
  margin-right: 5px;

  &:hover {
    border-color: ${colors.teal} !important;
    color: ${props =>
      props.type === "secondary" ? colors.primary : colors.tertiary} !important;
    font-weight: 600;
  }

  ${media.tablet`
  `}
`

export default class SignatureInput extends React.Component {
  state = {
    signature: null,
  }

  clear() {
    this.drawableCanvas.clear()
  }

  render() {
    return (
      <SignatureWrapper>
        <DrawableCanvas
          onDrawing={newSignature => {
            this.setState({
              signature: newSignature,
            })
          }}
          value={this.props.signature}
          ref={drawableCanvas => (this.drawableCanvas = drawableCanvas)}
        />
        <SignatureLine>Unterschrift</SignatureLine>
        <Button
          type="secondary"
          onClick={() => {
            this.clear()
            this.setState({ signature: null })
          }}
        >
          Zurücksetzen
        </Button>
        <Button
          onClick={event => {
            this.props.onSignatureChange(this.state.signature)
            this.props.onClose(event)
          }}
        >
          Okay
        </Button>
      </SignatureWrapper>
    )
  }
}
